import React from 'react';
import './CommentsThread.scss';
import Comment from './Comment';
import LoadMore from './LoadMore';

class CommentsThread extends React.Component{

  constructor(props){
    super(...arguments);

    let user = FW.store.get('user');
    let showApproved = user ? user.may('manage_blog_comments', props.parent) : false;
    let query = {parent_comment: null};
    if (!showApproved) {
      query.approved_at = {not: null};
    }
    props.parent.get('comments').addQuery(query);
    props.parent.get('comments').fetch().then(() => {
      if (props.onChildUpdate)
        props.onChildUpdate();
    });

    this.state = {};

    this.loadMore = this.loadMore.bind(this);
    this.scrollCheck = this.scrollCheck.bind(this);
  }

  scrollCheck(){
    let pos = this._loadMorePosition || {};
    let scrollTop = $(window).scrollTop() + $(window).height();
    if (scrollTop > pos.top && !this.state.loading){
      this.loadMore();
    }
  }

  componentDidMount(){
    let comments = this.props.parent.get('comments');
    comments.on('update', () => {
      this.setState({
        loading: false
      });
    }, this);
    $(window).on('scroll', this.scrollCheck);
  }

  componentDidUpdate(){
    if (this._loadMore){
      let pos = $(this._loadMore.refs.wrapper).offset();
      this._loadMorePosition = pos;
    } else {
      this._loadMorePosition = {};
    }
  }

  componentWillUnmount(){
    let comments = this.props.parent.get('comments');
    comments.off(null, null, this);
    $(window).off('scroll', this.scrollCheck);
  }

  loadMore(){
    this.setState({
      loading: true
    });
    this.props.parent.get('comments').loadMore();
  }

  onDelete = () => {
    this.setState({
      loading: false
    });
  };

  render(){
    let commentCollection = this.props.parent.get('comments');

    let comments = this.props.parent.get('comments').map((comment) => {
      return <Comment showApproved={this.state.showApproved} comment={comment} key={`comment-${comment.get('id')}`} parent={this.props.parent} onDelete={this.onDelete} />;
    });

    let showLoadMore = commentCollection.length < commentCollection.pagination.total;
    let loadMore = showLoadMore ? <LoadMore ref={(c) => {this._loadMore = c;}} onClick={this.loadMore} loading={this.state.loading} /> : null;

    return (
      <div className="comments-thread-wrapper">
        {comments}
        {loadMore}
      </div>
    );
  }

}

export default CommentsThread;
